/**
 * DEV-258 — sessão emitida pelo BFF depois do Onboarding. Fica no
 * sessionStorage da aba, por link: fechar a aba encerra o acesso.
 */
export interface StoredAlignmentSession {
  sessionToken: string;
  jobDescriptionId: string;
  expiresAt: string;
}

const key = (formId: string) => `alignment-session:${formId}`;

export function saveAlignmentSession(formId: string, session: StoredAlignmentSession): void {
  try {
    sessionStorage.setItem(key(formId), JSON.stringify(session));
  } catch {
    // Armazenamento indisponível (aba privada): a sessão vive só em memória do fluxo.
  }
}

export function clearAlignmentSession(formId: string): void {
  try {
    sessionStorage.removeItem(key(formId));
  } catch {
    // ignora
  }
}

export function loadAlignmentSession(formId: string, now: Date): StoredAlignmentSession | null {
  let raw: string | null;
  try {
    raw = sessionStorage.getItem(key(formId));
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<StoredAlignmentSession>;
    const expires = Date.parse(parsed.expiresAt ?? '');
    if (
      typeof parsed.sessionToken === 'string' &&
      typeof parsed.jobDescriptionId === 'string' &&
      Number.isFinite(expires) &&
      expires > now.getTime()
    ) {
      return parsed as StoredAlignmentSession;
    }
  } catch {
    // corrompida
  }
  clearAlignmentSession(formId);
  return null;
}
